const identity = n => n

import {
  asDecimal,
  asDecimalPercent,
  asWholeNumber,
  asWholePercent,
  asBillions
} from 'lib/format'

export const FORMATTING_MAP = {
  Exp5YRReturn: asWholePercent,
  Exp5YRExNet: asWholePercent,
  Exp5YRExGross: asWholePercent,
  Exp5YRTrackingError: asWholePercent,
  Exp5YRInfoRatio: asDecimal(2),
  Exp5YREx95th: asDecimalPercent(1),
  Exp5YREx75th: asDecimalPercent(1),
  Exp5YREx50th: asDecimalPercent(1),
  Exp5YREx25th: asDecimalPercent(1),
  Exp5YREx5th: asDecimalPercent(1),
  Exp5YR95th: asDecimalPercent(1),
  Exp5YR75th: asDecimalPercent(1),
  Exp5YR50th: asDecimalPercent(1),
  Exp5YR25th: asDecimalPercent(1),
  Exp5YR5th: asDecimalPercent(1),
  Exp5YRGross: asDecimalPercent(1),
  Exp5YRRealNet: asWholePercent,
  Exp5YRRealGross: asWholePercent,
  Exp5YRReal95th: asDecimalPercent(1),
  Exp5YRReal75th: asDecimalPercent(1),
  Exp5YRReal50th: asDecimalPercent(1),
  Exp5YRReal25th: asDecimalPercent(1),
  Exp5YRReal5th: asDecimalPercent(1),
  Exp5YRNomNet: asWholePercent,
  Exp5YRNomGross: asWholePercent,
  Exp5YRNom95th: asDecimalPercent(1),
  Exp5YRNom75th: asDecimalPercent(1),
  Exp5YRNom25th: asDecimalPercent(1),
  Exp5YRNom5th: asDecimalPercent(1),
  Exp5YRVol: asWholePercent,
  Exp5YRSharpe: asDecimal(2),
  Exp5YRBeta: asDecimal(2),
  HistITDReturn: asWholePercent,
  HistITDExNet: asWholePercent,
  HistITDExGross: asWholePercent,
  HistITDTrackingError: asWholePercent,
  HistITDInfoRatio: asDecimal(2),
  HistITDRealNet: asWholePercent,
  HistITDRealGross: asWholePercent,
  HistITDNomNet: asWholePercent,
  HistITDNomGross: asWholePercent,
  HistITDStructAlpha: asDecimalPercent(2),
  HistITDRevalAlpha: asDecimalPercent(2),
  HistITDVol: asWholePercent,
  HistITDSharpe: asDecimal(2),
  HistITDBeta: asDecimal(2),
  Hist5YRReturn: asWholePercent,
  Hist5YRExNet: asWholePercent,
  Hist5YRExGross: asWholePercent,
  Hist5YRTrackingError: asWholePercent,
  Hist5YRInfoRatio: asDecimal(2),
  Hist5YRRealNet: asWholePercent,
  Hist5YRRealGross: asWholePercent,
  Hist5YRNomNet: asWholePercent,
  Hist5YRNomGross: asWholePercent,
  Hist5YRVol: asWholePercent,
  Hist5YRSharpe: asDecimal(2),
  Hist5YRBeta: asDecimal(2),
  CurrentRelValAgg: asDecimal(2),
  CurrentRelValPB: asDecimal(2),
  MedianPBVal: asDecimal(2),
  TranCost: asDecimalPercent(1),
  Capacity: asBillions,
  Turnover: asWholePercent,
  WAMC: asBillions,
  EffStockCount: asWholeNumber,
  RelValPB10th: asDecimalPercent(1),
  RelValPB25th: asDecimalPercent(1),
  RelValPB50th: asDecimalPercent(1),
  RelValPB75th: asDecimalPercent(1),
  RelValPB90th: asDecimalPercent(1),
  RelValAgg10th: asDecimalPercent(1),
  RelValAgg50th: asDecimalPercent(1),
  RelValAgg90th: asDecimalPercent(1),
  WealthGrowth: asDecimal(2),
  Subsequent5YR: asWholePercent,
  RelValAgg: asDecimal(2)
}

export const TABLE_FORMATTING_MAP = {
  ...FORMATTING_MAP,
  Exp5YREx95th: asDecimalPercent(1),
  Exp5YREx75th: asDecimalPercent(1),
  Exp5YRExGross: asDecimalPercent(2),
  Exp5YREx25th: asDecimalPercent(1),
  Exp5YREx5th: asDecimalPercent(1),
  Exp5YRExNet: asDecimalPercent(2),
  Exp5YRRealNet: asDecimalPercent(2),
  Exp5YRReal95th: asDecimalPercent(1),
  Exp5YRReal75th: asDecimalPercent(1),
  Exp5YRRealGross: asDecimalPercent(2),
  Exp5YRReal25th: asDecimalPercent(1),
  Exp5YRReal5th: asDecimalPercent(1),
  Exp5YRNom95th: asDecimalPercent(1),
  Exp5YRNom75th: asDecimalPercent(1),
  Exp5YRNomGross: asDecimalPercent(2),
  Exp5YRNom25th: asDecimalPercent(1),
  Exp5YRNom5th: asDecimalPercent(1),
  Exp5YRNomNet: asDecimalPercent(2),
  HistITDExNet: asDecimalPercent(2),
  HistITDExGross: asDecimalPercent(2),
  HistITDRealNet: asDecimalPercent(2),
  HistITDRealGross: asDecimalPercent(2),
  HistITDNomNet: asDecimalPercent(2),
  HistITDNomGross: asDecimalPercent(2),
  Exp5YRTrackingError: asDecimalPercent(1),
  RelValAgg50th: asDecimal(2),
  RelValPB50th: asDecimal(2),
  HistITDReturn: asDecimalPercent(1),
  Hist5YRReturn: asDecimalPercent(1),
  Exp5YRReturn: asDecimalPercent(2),
  TranCost: asDecimalPercent(2),
  HistITDTrackingError: asDecimalPercent(1),
  Hist5YRTrackingError: asDecimalPercent(1),
  Exp5YRVol: asDecimalPercent(1),
  HistITDVol: asDecimalPercent(1),
  Hist5YRVol: asDecimalPercent(1),
  Turnover: asDecimalPercent(1),
  Exp5YR95th: asDecimalPercent(2),
  Exp5YR75th: asDecimalPercent(2),
  Exp5YR50th: asDecimalPercent(2),
  Exp5YR25th: asDecimalPercent(2),
  Exp5YR5th: asDecimalPercent(2),

  Hist5YRRealNet: asDecimalPercent(2),
  Hist5YRRealGross: asDecimalPercent(2),
  Hist5YRNomNet: asDecimalPercent(2),
  Hist5YRNomGross: asDecimalPercent(2),
  Hist5YRExNet: asDecimalPercent(2),
  Hist5YRExGross: asDecimalPercent(2)
}

export default function format(n, formatKey, formatMap = FORMATTING_MAP) {
  let formatted = n

  try {
    formatted = formatMap[formatKey](n)
  } catch (e) {
    if (console && console.warn) {
      console.warn('tried to format: ' + n, formatKey)
      console.warn('number format error: ' + e)
    }
  }

  return formatted
}

export function formatTable(n, formatKey) {
  return format(n, formatKey, TABLE_FORMATTING_MAP)
}

export function formatFor(key, formatMap = FORMATTING_MAP) {
  return formatMap[key] || identity
}



// WEBPACK FOOTER //
// ./src/format.js